var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isFinanceAdmin || _vm.isAdmin)?_c('div',{},[_c('h3',{staticClass:"page-title text-center"},[_vm._v(_vm._s(_vm.title))]),_c('cc-list-box',{attrs:{"columns":_vm.columns,"rows":_vm.certificateList,"showPagination":true,"pagination":_vm.pagination},on:{"add":_vm.onAdd,"edit":_vm.onEdit,"delete":_vm.onDelete}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }